import React from 'react'
import {connect} from 'react-redux'
import {formValueSelector} from 'redux-form'
import {getCurrent} from "../steps/StepsReducers";
import {select, finish} from "../steps/StepsActions";
import {STEP_SETUP_ENVIRONMENT} from "../steps/StepsContants";
import {receive} from '../result/ResultActions';
import './UpdatePi.css';
import html from 'react-escape-html'
import UpdatePiForm from "./UpdatePiForm";
import {getWidgetRef, isUpdatePiLoaded} from "./UpdatePiReducer";
import {
  updatePiValidate,
  updatePiAddValidationListener,
  updatePiRemoveValidationListener,
  updatePiLoaded,
  updatePiValidateResult
} from "./UpdatePiActions";

const UpdatePiContainer = ({state, currentStep, select, finish, receive, isLoaded, widgetRef, updatePiValidate, updatePiAddValidationListener, updatePiRemoveValidationListener, updatePiLoaded, updatePiValidateResult}) => {

  const previous = () => {
    select(STEP_SETUP_ENVIRONMENT);
  };

  const onWidgetResult = (error, result) => {
    receive(error, result);
    finish();
  };

  const getConfigUrl = () => {
    let scriptTag = `<script src="${state.config.environment.widgetUrl}"></script>`;
    return html`${scriptTag}`;
  };

  const getVlidationResults = () => {
    if (state.updatePi.validationListenerAdded) {
      return JSON.stringify(state.updatePi.validationResult, null, 2);
    }
    return 'You should call addValidationListener() function';
  };

  const getValidateResult = () => {
    return JSON.stringify(state.updatePi.validateResult, null, 2);
  };

  //integration methods
  const validationListenerCallback = (data) => {
    console.log('Validation listener callback', data);
    updatePiValidate(data);
  };

  const addValidationListener = () => {
    console.log('Widget REF: ', widgetRef);
    window.PayEngineWidget.addValidationListener(widgetRef, validationListenerCallback);
    updatePiAddValidationListener();
  };

  const removeValidationListener = () => {
    window.PayEngineWidget.removeValidationListener(widgetRef, validationListenerCallback);
    updatePiRemoveValidationListener();
  };

  const pay = () => {
    const onPayCallback = (error, result) => {
      console.log("On pay callback", error, result);
    };
    window.PayEngineWidget.pay(widgetRef, onPayCallback);
  };

  const validate = () => {
    function onValidationCallback(error, result) {
      console.log('Validate', error, result);
      updatePiValidateResult(error ? error : result);
    }

    window.PayEngineWidget.validate(widgetRef, onValidationCallback);
  };

  const initCallback = (error, iframeName) => {
    console.log("Init callback", error, iframeName);
    widgetRef = iframeName;
    updatePiLoaded(widgetRef);
  };

  const getOptionalParameters = () => {
    const selector = formValueSelector('update-pi');
    const optionalParameters = selector(
      state, 'language', 'customStyleId', 'hidePayButton'
    );
    optionalParameters.initCallback = initCallback;

    return optionalParameters;
  };

  const getOptionalParametersTemplate = () => {
    let params =
      `var optionalParameters = ${JSON.stringify(getOptionalParameters(), null, 2)}
optionalParameters.initCallback = initCallback;
`;
    return html`${params}`;
  };

  const getResultCallback = () => {
    const callbackCode =
      `var widgetRef;

function validationListenerCallback(data) {
  console.log('Validation listener callback', data);
}

function addValidationListener() {
  PayEngineWidget.addValidationListener(widgetRef, validationListenerCallback);
}

function removeValidationListener() {
  PayEngineWidget.removeValidationListener(widgetRef, validationListenerCallback);
}

function pay() {
  function onPayCallback(error, result) {
    console.log("On pay callback", error, result);
  }
  PayEngineWidget.pay(widgetRef, onPayCallback);
}

function validate() {
  function onValidationCallback(error, result) {
    console.log('Validate', error, result);
  }
  PayEngineWidget.validate(widgetRef, onValidationCallback);
}


function initCallback(error, iframeName) {
  console.log("Init callback", error, iframeName);
  widgetRef = iframeName;
}

function resultCallback(error, results) {
  console.log('Error/Result:', error, results);
}`;
    return html`${callbackCode}`;
  }

  const getInitiWidget = () => {
    const selector = formValueSelector('update-pi');
    const values = selector(state, 'merchantId', 'paymentInstrumentId');
    let params = `
PayEngineWidget.initAsInlineComponentPiUpdate(
  "update-pi-widget-container",
  '${values.merchantId}',
  '${values.paymentInstrumentId}',
  optionalParameters,
  resultCallback
);
    `;
    return html`${params}`;
  };

  let callbacksActionsContent = '';
  if (isLoaded) {
    callbacksActionsContent =
      <div>
        <div className="clearfix"></div>
        <hr/>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-xs-3">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={addValidationListener}>
                <span className="btn-text">addValidationListener()</span>
              </button>
            </div>
            <div className="col-xs-3 text-center">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={removeValidationListener}>
                <span className="btn-text">removeValidationListener()</span>
              </button>
            </div>
            <div className="col-xs-3">
              <button type="button" className="btn btn-primary col-xs-12" onClick={validate}>
                <span className="btn-text">validate()</span>
              </button>
            </div>
            <div className="col-xs-3">
              <button type="button" className="btn btn-primary col-xs-12" onClick={pay}>
                <span className="btn-text">update()</span>
              </button>
            </div>
          </div>
        </div>
      </div>
  }

  let onSubmit = values => {
    document.getElementById('update-pi-widget-container').innerHTML = '';
    removeValidationListener();
    window.PayEngineWidget.initAsInlineComponentPiUpdate(
      'update-pi-widget-container',
      values.merchantId,
      values.paymentInstrumentId,
      getOptionalParameters(),
      onWidgetResult
    );
    window.scrollTo(0, 1000);
  };

  return (
    <div className="row">
      <div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <UpdatePiForm onSubmit={values => onSubmit(values)} onPrevious={previous}/>
        </div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <h3>Configuration</h3>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getConfigUrl()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getResultCallback()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getOptionalParametersTemplate()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getInitiWidget()}></div>
        </pre>
          </blockquote>
        </div>
      </div>
      <div>
        <div className="text-center">
          <hr/>
          <h3>Widget</h3>
          {callbacksActionsContent}
        </div>
        <div className="clearfix"></div>
        <hr/>
        <div className="row">
          <div className="col-lg-6 col-md-12 col-xs-12 text-center">
            <h5>The widget will be loaded here (iframe)</h5>
            <div className="widget-container">
              <div id="update-pi-widget-container"></div>
            </div>
          </div>
          {
            isLoaded ?
              <div className="col-lg-6 col-md-12 col-xs-12">
                <h5>Validation listener callback</h5>
                <blockquote>
              <pre>
                {getVlidationResults()}
              </pre>
                </blockquote>
                <h5>Validate</h5>
                <blockquote>
                  <pre>
                    {getValidateResult()}
                  </pre>
                </blockquote>
              </div> : ''
          }
        </div>

      </div>
    </div>
  );
};

UpdatePiContainer.propTypes = {};

const mapStateToProps = (state) => ({
  state: state,
  currentStep: getCurrent(state),
  isLoaded: isUpdatePiLoaded(state),
  widgetRef: getWidgetRef(state)
});

export default connect(
  mapStateToProps,
  {
    select,
    finish,
    receive,
    updatePiValidate,
    updatePiAddValidationListener,
    updatePiRemoveValidationListener,
    updatePiLoaded,
    updatePiValidateResult
  }
)(UpdatePiContainer);



// WEBPACK FOOTER //
// ./src/update-pi/UpdatePiContainer.js